import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import Modal from 'react-modal';
import Utils from 'medscape/utils';
import Helpers from 'infosite/helpers';
import ZoomImage from './image';
import CloseButton from './close-button';
export default class ZoomContent extends React.Component {
  constructor(props){
    super(props);
    this.state = {}
    //props.image.src = Utils.getCompiledHtml(props.image.src)
    //console.log("ZoomContent Constructed",props);
  }
  componentDidMount(){
    //let $this = $(ReactDOM.findDOMNode(this));
    //console.log("Zoom Layer Mounted!",$this[0]);
  }
  componentWillUpdate(nextProps,nextState){
    //nextProps.image.src = Utils.getCompiledHtml(nextProps.image.src)
  }


  render() {
    if(this.props.label.length==0 && this.props.caption.length==0){
      return (
          <div className="zoom-content-container">
            <div className="close-button-container">
              <CloseButton onClick={this.props.onClose} />
            </div>
            <ZoomImage image={this.props.image} />
          </div>    
      );
    }
    else{
      const label = Utils.getDangerousHtml(this.props.label);
      const caption = Utils.getDangerousHtml(this.props.caption);
      return (
            <div className="zoom-content-container label-caption">
              <div className="close-button-container">
                <CloseButton onClick={this.props.onClose} />
              </div>
              <ZoomImage image={this.props.image} />
              <div className="label-caption-container">
                <div className="zoom-label" dangerouslySetInnerHTML={label}></div>
                <div className="zoom-caption" dangerouslySetInnerHTML={caption}></div>
              </div>
            </div>
      );
    }
  } // render

}

ZoomContent.propTypes={
  "image": React.PropTypes.object.isRequired,
  "label": React.PropTypes.string,
  "caption": React.PropTypes.string,
  "onClose": React.PropTypes.func

}
ZoomContent.defaultProps={
  "label": "",
  "caption": "",
  "onClose": ()=>{}
}




// WEBPACK FOOTER //
// ./src/app/zoom-images/zoom-layer/zoom-content.jsx